import styled from "styled-components";

export const $SearchResultContainer = styled.div`
  margin-top: 16px;
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
`;
